import { goToNews } from '@/app/routing/events'
import { useStyles } from './styles'
import { useUnit } from 'effector-react'
import { $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'

export const EGSNews = () => {
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const text = lang[userLang].news.egs
  return (
    <div
      className={classes.root}
      onClick={() => goToNews({ variant: 'egs' })}
    >
      <p className={classes.title}>{text}</p>
    </div>
  )
}
